import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  public mapAvailableYears = ['2020', '2021', '2022'];
  // public mapAvailableYears = ['2021', '2022'];

  public selectedYearSource = new BehaviorSubject<any>(
    this.getSelectedYearFromStorage()
  );
  public selectedYear$ = this.selectedYearSource.asObservable();

  constructor() { }

  // Select year

  selectYearEvent(year) {
    this.selectedYearSource.next(year);
    this.saveSelectedYearINStorage(year);
  }

  saveSelectedYearINStorage(year) {
    localStorage.setItem('ibank_selected_year', year);
  }

  getSelectedYearFromStorage() {
    return JSON.parse(localStorage.getItem('ibank_selected_year')) ?? 2020;
  }

  removeSelectedYearFromStorage() {
    localStorage.removeItem('ibank_selected_year');
  }
}
